<div *ngIf="logoPosition === 'center'" class="header-container center">
  <div class="date">
    <ibex-icon name="calendar-tick" variant="blank"></ibex-icon>
    <div *ngIf="!isLoadingLanguage" class="text">
      <div>{{date | ibexDate: 'weekday'}}</div>
      <div>{{date | ibexDate: 'dd. LLLL yyyy'}}</div>
    </div>
  </div>
  <div class="clock">
    <clock [color]="clockColor" [elId]="clockId" [fontSize]="35" [size]="60" digitsPosition="left"></clock>
  </div>
</div>

<div *ngIf="logoPosition === 'right'" class="header-container right">
  <div class="clock">
    <clock [color]="clockColor" [elId]="clockId" [fontSize]="35" [size]="60" digitsPosition="none"></clock>
  </div>
  <div class="date">
    <div *ngIf="!isLoadingLanguage" class="text">
      <div>{{date | ibexDate: 'weekday'}}</div>
      <div>{{date | ibexDate: 'dd. LLLL yyyy'}}</div>
      <div>{{date | ibexDate: 'time'}}</div>
    </div>
  </div>
</div>

<div *ngIf="logoPosition === 'left'" class="header-container left">
  <div class="date">
    <div *ngIf="!isLoadingLanguage" class="text">
      <div>{{date | ibexDate: 'weekday'}}</div>
      <div>{{date | ibexDate: 'dd. LLLL yyyy'}}</div>
      <div>{{date | ibexDate: 'time'}}</div>
    </div>
  </div>
  <div class="clock">
    <clock [color]="clockColor" [elId]="clockId" [fontSize]="35" [size]="60" digitsPosition="none"></clock>
  </div>
</div>

<div *ngIf="logoPosition === 'left-right'" class="header-container left-right">
  <div class="inner-container">
    <div class="date">{{date | ibexDate: 'fullDate'}}</div>
    <div class="time">{{date | ibexDate: 'HH:mm'}}</div>
  </div>
</div>
